// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantsBoardColumnEmpty-moduleRentalPortalApplicantsBoardColumnEmpty__Ce_iC";
export { _1 as "RentalPortalApplicantsBoardColumnEmpty" }
